import React from 'react';

type Step = 1 | 2 | 3 | 4;

const LABELS: Record<Step, string> = {
  1: 'Настройка',
  2: 'Лобби',
  3: 'Выбор',
  4: 'Результаты',
};

interface SessionProgressProps {
  step: Step;
  className?: string;
}

const SessionProgress: React.FC<SessionProgressProps> = ({ step, className = 'mb-6' }) => (
  <div className={`w-full ${className}`}>
    <div className="flex items-start w-full">
      {([1, 2, 3, 4] as Step[]).map((s) => (
        <React.Fragment key={s}>
          <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
            <div
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                s < step
                  ? 'bg-orange-400'
                  : s === step
                  ? 'bg-orange-500 scale-125'
                  : 'bg-gray-200'
              }`}
            />
            <span
              className={`text-[11px] leading-none whitespace-nowrap transition-colors duration-300 ${
                s === step
                  ? 'text-orange-500 font-semibold'
                  : s < step
                  ? 'text-orange-300'
                  : 'text-gray-300'
              }`}
            >
              {LABELS[s]}
            </span>
          </div>
          {s < 4 && (
            <div
              className={`flex-1 h-0.5 rounded-full mt-[4px] transition-all duration-300 ${
                s < step ? 'bg-orange-400' : 'bg-gray-200'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default SessionProgress;
